// src/components/RevisionHistory.js
import React from 'react';

function RevisionHistory() {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-[1200px] mx-auto p-8 bg-white rounded-lg shadow-lg">
        <h1 className="text-center mb-8 text-4xl font-extrabold text-gray-900">
          改定履歴
        </h1>
        <h2 className="mt-4 mb-4 text-2xl font-semibold border-b-2 border-gray-300 pb-2 text-primary">
          改定履歴
        </h2>
        <ul className="ml-6 list-disc text-gray-700">
          <li className="mb-2">2025年2月10日: 初版作成</li>
          <li className="mb-2">2025年2月11日: 禁止事項および個人情報管理ポリシーを追加</li>
          <li>2025年2月12日: プライバシーポリシーのアクセス解析・クッキー等について言及</li>
        </ul>
      </div>
    </div>
  );
}

export default RevisionHistory;
